<template>
  <div class="if-block">
    <h3 class="if-block__title">{{ $t('view.flow.block.if.title') }}</h3>
    <div class="if-block__condition-wrapper">
      <h4>{{ $t('view.flow.block.if.if') }}</h4>
      <in
        class="if-block__condition-input"
        :label="$t('view.flow.block.if.condition')"
        v-model="val.condition"
        @input="onInput"
      ></in>
    </div>
    <div class="if-block__dragzone">
      <steps-core
        ref="stepsCore"
        v-model="val.steps"
        :blockId="blockId"
        @singleStepMenu="$emit('singleStepMenu', $event)"
        @del="deleteStep($event, 'steps')"
      ></steps-core>
    </div>
    <h4>{{ $t('view.flow.block.if.else') }}</h4>
    <div class="if-block__dragzone">
      <steps-core
        ref="elseStepsCore"
        v-model="val.elseSteps"
        :blockId="blockId"
        @singleStepMenu="$emit('singleStepMenu', $event)"
        @del="deleteStep($event, 'elseSteps')"
      ></steps-core>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    deleteStep (id, arrName) {
      for (let i = 0; i < this.val[arrName].length; i++) {
        if (this.val[arrName][i].uuid === id) {
          this.$delete(this.val[arrName], i)
          this.onInput()
          break
        }
      }
    },

    async beforeSave () {
      await this.runHooks('beforeSave')
    },

    async runHooks (hookName) {
      await this.$refs.stepsCore.runHooks(hookName)
      await this.$refs.elseStepsCore.runHooks(hookName)
    }
  }
}
</script>

<style lang="scss" scoped>
.if-block {
  @include flowElementShadow;
  width: 90%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 10px 10px 14px;

  &__dragzone {
    background-color: #f1f1f1;
    border-radius: 4px;
    padding: 3px 10px 5px 10px;
  }

  &__condition-wrapper {
    @include alignedFlex;
    justify-content: flex-start;

    & > h4 {
      margin-right: 12px;
    }
  }

  &__condition-input {
    width: 80%;
    margin-top: -16px;
  }
}
</style>
